import { ComponentStyleConfig } from '@chakra-ui/theme';

const container: ComponentStyleConfig = {
  baseStyle: {
    w: 'full',
    //maxW: '1198',
    maxW: '1600',
    display: 'flex',
    mx: 'auto',
    px: {
      base: '23px',
      lg: '32px'
    },
    py: {
      base: '23px',
      lg: '45px'
    }
  },
  variants: {
    internal: {
      //maxW: '1440',
      maxW: '1440',
      px: {
        base: '23px',
        lg: '92px'
      },
    }
  }
};

export default container;
